export default "__VITE_ASSET__vG_Q00nZ__"